import React, { useState } from "react";

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    // Send data to Formspree
    const response = await fetch("https://formspree.io/f/mwpwdjne", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    });

    if (response.ok) {
      setSubmitted(true);
      form.reset();
    } else {
      alert("Oops! Something went wrong. Please try again later.");
    }
  };

  return (
    <section className="bg-white py-16 px-6 lg:px-16">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-start">
        
        {/* Contact Form */}
        <div className="bg-blue-50 p-8 rounded-2xl shadow-md">
          {submitted ? (
            <div className="text-center py-20">
              <h3 className="text-2xl font-bold text-blue-700 mb-4">
                Thank You!
              </h3>
              <p className="text-gray-700">
                Your message has been sent successfully. Our HR team will contact you shortly.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your full name"
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  name="message"
                  placeholder="Write your message here..."
                  rows="5"
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg shadow transition-all"
              >
                Send Message
              </button>
            </form>
          )}
        </div>

        {/* Contact Details */}
        <div className="space-y-6">
          <div className="bg-white shadow p-8 rounded-2xl border border-gray-100">
            <h3 className="text-2xl font-bold text-blue-700 mb-6">
              Contact Information
            </h3>
            <p className="text-gray-700 mb-2">
              <strong>Full Name:</strong> Priyanka Reddy Lekireddy
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Email:</strong>{" "}
              <a
                href="mailto:hr@blueshieldlabs.com"
                className="text-blue-600 hover:underline"
              >
                hr@blueshieldlabs.com
              </a>
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Address:</strong> 1413 David Dr, Anna, Texas 75409
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Phone:</strong>{" "}
              <a
                href="tel:+19402904554"
                className="text-blue-600 hover:underline"
              >
                +1 940 290 4554
              </a>
            </p>
            <p className="text-gray-700">
              <strong>Website:</strong>{" "}
              <a
                href="https://www.blueshieldlabs.com"
                className="text-blue-600 hover:underline"
                target="_blank"
                rel="noreferrer"
              >
                www.blueshieldlabs.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
